//ecd:1251203291H20261022084009_V3.0
import { request, requestOrNull, seg, Page, ApiError } from './apiSupport';
import { CustomerDTO } from './CustomerDTO';
import { CustomerKeyDTO } from './CustomerKeyDTO';
import { CustomerSrchDTO } from './CustomerSrchDTO';

/**
 * REST client for Customer.
 *
 * Calls the endpoints CustomerController exposes. Generated from the same model the
 * server is, so a change to the DSL shows up here as a type error rather than
 * at runtime.
 *
 * Generated by ElastiCORE. Do not edit outside the ElastiCORE guidelines.
 */
const BASE = '/api/petstore/customer';

/** Registers a new Customer. */
export async function create(input: CustomerDTO): Promise<CustomerDTO> {
    return request<CustomerDTO>('POST', BASE, input);
}

/** The Customer with this identifier, or null when there is none. */
export async function findById(customerId: number): Promise<CustomerDTO | null> {
    return requestOrNull<CustomerDTO>('GET', BASE + '/' + seg(customerId));
}

/** Every Customer matching the condition. */
export async function search(condition: CustomerSrchDTO): Promise<Page<CustomerDTO>> {
    return request<Page<CustomerDTO>>('POST', BASE + '/search', condition);
}

/** Updates an existing Customer. */
export async function update(input: CustomerDTO): Promise<CustomerDTO> {
    return request<CustomerDTO>('PUT', BASE, input);
}

/** Updates several in one transaction; none are applied if any fails. */
export async function batchUpdate(inputs: CustomerDTO[]): Promise<void> {
    return request<void>('PUT', BASE + '/batch', inputs);
}

/** Deletes each key, answering for each whether it was there. */
export async function deleteMany(keys: CustomerKeyDTO[]): Promise<boolean[]> {
    return request<boolean[]>('POST', BASE + '/delete', keys);
}

/** Deletes the Customer with this identifier. */
export async function deleteById(customerId: number): Promise<boolean> {
    return request<boolean>('DELETE', BASE + '/' + seg(customerId));
}

/** Signs in: the session cookie is set (same origin) and the Customer answered; ApiError 401 when the login or the password is wrong. */
export async function signIn(login: string, password: string): Promise<CustomerDTO> {
    return request<CustomerDTO>('POST', BASE + '/signin', { login, password });
}

/** Signs out: the session ends. */
export async function signOut(): Promise<void> {
    return request<void>('POST', BASE + '/signout');
}

/** The Customer signed in now, or null for a visitor. */
export async function me(): Promise<CustomerDTO | null> {
    try {
        return await request<CustomerDTO>('GET', BASE + '/me');
    } catch (e) {
        if (e instanceof ApiError && e.status === 401) return null;
        throw e;
    }
}

